export default __webpack_public_path__ + "static/media/medium-black.d4869399.png";